import React, { Component } from 'react';
import countries from './countries';

const ALLOWED_COUNTRIES = countries.filter(country => !country.isRestricted);
const ALLOWED_COUNTRIES_BY_CONTEXT = {
	REGISTRATION: ALLOWED_COUNTRIES,
	PNET: ALLOWED_COUNTRIES,
	NCRP: ALLOWED_COUNTRIES.slice(0, 2)
}

const getCountryByCode = code => countries.find(country => country.code === code);

const USA_STATES = ['AL','AK','AR','AZ','CA','CO','CT','DC','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME',
	'MI','MN','MO','MS','MT','NC','ND','NH','NE','NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY'];
const CANADA_PROVINCES = getCountryByCode('CA').regions.map(region => region.code);

const ADDRESS_TYPES_BY_CONTEXT = {
	PNET: [
		{
			value: 'SHIP_TO_SITE',
			label: 'Ship To Site'
		},
		{
			value: 'CONSUMER',
			label: 'Consumer'
		}
	],
	NCRP: [
		{
			value: 'RESIDENTIAL',
			label: 'Residential'
		},
		{
			value: 'COMMERCIAL',
			label: 'Commercial'
		}
	]
};
class ShipToAddress extends Component {
	constructor(props) {
		super(props);

		const address = this.props.address || {};
		const country = address.country || 'US';

		const state = {
			fields: {
				type:
					address.type ||
					(props.context === 'REGISTRATION'
						? undefined
						: props.context === 'NCRP'
						? 'COMMERCIAL'
						: props.isInternational
						? 'SHIP_TO_SITE'
						: country === 'US'
						? 'CONSUMER'
						: 'SHIP_TO_SITE'),
				country,
				name: address.name || (props.context === 'REGISTRATION' ? undefined : ''),
				companyName: address.companyName || (props.context === 'REGISTRATION' ? undefined : ''),
				addressLine1: address.addressLine1 || '',
				addressLine2: address.addressLine2 || '',
				addressLine3: address.addressLine3 || '',
				city: address.city || '',
				state: address.state || '',
				province:
					address.country === 'CA' && address.province
						? (getCountryByCode(address.country).regions.find(
								region => region.name.toUpperCase() === address.province.toUpperCase() || region.code === address.province.toUpperCase()
						  ) || { code: '' }).code
						: address.province || '',
				zipCode: address.zipCode || '',
				postalCode: address.postalCode || ''
				// phoneNumber: address.phoneNumber || ''
			},
			errors: {
				country: false,
				name: false,
				companyName: false,
				addressLine1: false,
				addressLine2: false,
				addressLine3: false,
				city: false,
				state: false,
				province: false,
				zipCode: false,
				postalCode: false
				// phoneNumber: false
			}
		};

		if (props.context === 'REGISTRATION') {
			state.fields.phoneNumber = address.phoneNumber || '';
			state.errors.phoneNumber = false;
		}

		this.state = state;
	}

	isCountrySelected = countryCode => this.state.fields.country === countryCode;

	isValidPhoneNumber = (phoneNumber, country) => {
		if (['US', 'CA'].includes(country || this.state.fields.country)) {
			return /^1?[2-9][0-9]{9}$/.test(phoneNumber.replace(/\D+/g, ''));
		}
		return /^\+?[0-9]{1,20}$/.test(phoneNumber.trim());
	};

	normalizePhoneNumber = (phoneNumber, country) => {
		let formattedPhoneNumber = phoneNumber.trim();
		if (['US', 'CA'].includes(country)) {
			formattedPhoneNumber = formattedPhoneNumber.replace(/\D+/g, '');
			if (/^1?([2-9]\d{2})(\d{3})(\d{4})$/.test(formattedPhoneNumber)) {
				let npa = RegExp.$1;
				let nxx = RegExp.$2;
				let xxxx = RegExp.$3;
				formattedPhoneNumber = '(%s) %s-%s'.replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
				return formattedPhoneNumber;
			}
			return phoneNumber;
		}
		formattedPhoneNumber =
			formattedPhoneNumber.charAt(0) === '+' ? formattedPhoneNumber.charAt(0) + formattedPhoneNumber.slice(1).replace(/\D+/g, '') : formattedPhoneNumber.replace(/\D+/g, '');
		return formattedPhoneNumber;
	};

	isFieldValid = (fieldName, fieldValue) => {
		if (fieldName === 'name' && ['CONSUMER', 'RESIDENTIAL'].includes(this.state.fields.type)) {
			if (this.props.context === 'NCRP') {
				if (!fieldValue.trim()) {
					return false;
				}
			} else {
				const nameSegments = fieldValue.trim().split(/\s+/);
				if (nameSegments.length < 2) {
					return false;
				}
			}
		} else if (fieldName === 'companyName' && this.state.fields.type === 'COMMERCIAL') {
			if (!fieldValue.trim()) {
				return false;
			}
		} else if (['country', 'addressLine1', 'city'].includes(fieldName)) {
			if (fieldValue.trim() === '') {
				return false;
			}
		} else if (fieldName === 'phoneNumber') {
			if (fieldValue.trim() === '' || !this.isValidPhoneNumber(fieldValue)) {
				return false;
			}
		} else if (this.isCountrySelected('US')) {
			if (fieldName === 'zipCode') {
				if (!/\d{5}(-?\d{4})?$/.test(fieldValue)) {
					return false;
				}
			} else if (fieldName === 'state') {
				if (fieldValue.trim() === '') {
					return false;
				}
			}
		} else if (this.isCountrySelected('CA')) {
			if (fieldName === 'postalCode') {
				if (!/^[A-Za-z0-9]{2,4}\s?[A-Za-z0-9]{2,4}$/.test(fieldValue)) {
					return false;
				}
			} else if (fieldName === 'province') {
				if (fieldValue.trim() === '') {
					return false;
				}
			}
		}

		return true;
	};

	onKeyPressOfNumber(event) {
		if (event.charCode < 48 || event.charCode > 57) event.preventDefault();
	}

	handleChange = event => {
		const { name: fieldName, value: fieldValue } = event.target;
		const addressData = JSON.parse(JSON.stringify(this.state));

		addressData.fields[fieldName] = fieldValue;

		if (fieldName === 'country') {
			addressData.fields.state = '';
			addressData.errors.state = false;

			addressData.fields.zipCode = '';
			addressData.errors.zipCode = false;

			addressData.fields.postalCode = '';
			addressData.errors.postalCode = false;

			addressData.fields.province = '';
			addressData.errors.province = false;

			if (addressData.fields.phoneNumber && addressData.fields.phoneNumber.trim()) {
				addressData.fields.phoneNumber = this.normalizePhoneNumber(addressData.fields.phoneNumber, fieldValue);
				addressData.errors.phoneNumber = !this.isValidPhoneNumber(addressData.fields.phoneNumber, fieldValue);
			}
		}

		if (this.state.errors[fieldName] && this.isFieldValid(fieldName, fieldValue)) {
			addressData.errors = {
				...addressData.errors,
				[fieldName]: false
			};
		}

		this.setState(addressData);
	};

	handleBlur = event => {
		const { name: fieldName, value: fieldValue } = event.target;
		const addressData = JSON.parse(JSON.stringify(this.state));

		if (fieldName === 'phoneNumber') {
			addressData.fields[fieldName] = this.normalizePhoneNumber(fieldValue, addressData.fields.country);

			if (!addressData.errors[fieldName] && !this.isFieldValid(fieldName, addressData.fields[fieldName])) {
				addressData.errors[fieldName] = true;
			}
		} else if (!addressData.errors[fieldName] && !this.isFieldValid(fieldName, fieldValue)) {
			addressData.errors[fieldName] = true;
		}

		this.setState(addressData);
	};

	updateFieldsWithFoundAddress = foundAddress => {
		this.setState({
			fields: {
				...this.state.fields,
				addressLine1: foundAddress.addressline1.trim(),
				addressLine2: foundAddress.addressline2.trim(),
				addressLine3: (foundAddress.addressline3 || '').trim(),
				city: foundAddress.city.trim(),
				state: foundAddress.state.trim(),
				zipCode: foundAddress.postalcode.trim(),
				postalCode: foundAddress.postalcode.trim()
			}
		});
	};

	validateFields = callback => {
		const addressData = JSON.parse(JSON.stringify(this.state));
		let formError = false;

		for (const fieldName in addressData.fields) {
			if (!this.isFieldValid(fieldName, addressData.fields[fieldName])) {
				addressData.errors[fieldName] = true;
				formError = true;
			} else {
				addressData.errors[fieldName] = '';
			}
		}

		this.setState(
			{
				...addressData
			},
			() => {
				if (!formError) {
					if (this.isCountrySelected('US')) {
						const { province, postalCode, ...rest } = addressData.fields;
						callback(rest);
					} else {
						callback(addressData.fields);
					}
				}
			}
		);
	};

	render() {
		return (
			<div className="shipToAddress">
				{(this.props.context === 'NCRP' || (this.props.isInternational && this.props.context !== 'REGISTRATION')) && (
					<div className={`shipToAddressFormRow${this.state.errors.type ? ' error' : ''}`}>
						<label htmlFor="type">
							<b>
								Type<span className="required">*</span>:
							</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<select id="type" className="fullWidth" name="type" value={this.state.fields.type} onChange={this.handleChange} onBlur={this.handleBlur}>
								{ADDRESS_TYPES_BY_CONTEXT[this.props.context || 'PNET'].map(({ value, label }) => (
									<option key={value} value={value}>
										{label}
									</option>
								))}
							</select>
							{this.state.errors.type && <p className="message">Please select address type</p>}
						</div>
					</div>
				)}
				<div className={`shipToAddressFormRow${this.state.errors.country ? ' error' : ''}`}>
					<label htmlFor="country">
						<b>
							Country<span className="required">*</span>:
						</b>
					</label>
					<div className="shipToAddressFieldWrapper">
						<select
							id="country"
							className="fullWidth"
							name="country"
							value={this.state.fields.country}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							disabled={(this.props.context !== 'NCRP' && this.props.context !== 'REGISTRATION' && !this.props.isInternational) || this.props.disabledFields.country}
						>
							{(this.props.context !== 'NCRP' && this.props.context !== 'REGISTRATION' && !this.props.isInternational) || this.props.disabledFields.country ? (
								<option value={this.state.fields.country}>
									{(getCountryByCode(this.state.fields.country) || {}).name}
								</option>
							) : (
								<React.Fragment>
									<option value="" disabled>
										Select
									</option>
									{ALLOWED_COUNTRIES_BY_CONTEXT[this.props.context || 'PNET'].map(country => (
										<option key={country.code} value={country.code}>
											{country.name}
										</option>
									))}
								</React.Fragment>
							)}
						</select>
						{this.state.errors.country && <p className="message">Please select your country</p>}
					</div>
				</div>
				{['CONSUMER', 'RESIDENTIAL'].includes(this.state.fields.type) && (
					<div className={`shipToAddressFormRow${this.state.errors.name ? ' error' : ''}`}>
						<label htmlFor="name">
							<b>
								Name<span className="required">*</span>:
							</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<input
								type="text"
								id="name"
								className="fullWidth"
								name="name"
								value={this.state.fields.name}
								placeholder={this.props.context === 'NCRP' ? '' : 'First and last name'}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								disabled={this.props.disabledFields.name}
							/>
							{this.state.errors.name && <p className="message">{this.props.context === 'NCRP' ? "Name can't be empty" : 'Please enter full name'}</p>}
						</div>
					</div>
				)}
				{this.state.fields.type === 'COMMERCIAL' && (
					<div className={`shipToAddressFormRow${this.state.errors.companyName ? ' error' : ''}`}>
						<label htmlFor="companyName">
							<b>
								Company Name<span className="required">*</span>:
							</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<input
								type="text"
								id="companyName"
								className="fullWidth"
								name="companyName"
								value={this.state.fields.companyName}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								disabled={this.props.disabledFields.companyName}
							/>
							{this.state.errors.companyName && <p className="message">Please enter company name</p>}
						</div>
					</div>
				)}
				<div className={`shipToAddressFormRow${this.state.errors.addressLine1 ? ' error' : ''}`}>
					<label htmlFor="address-line-1">
						<b>
							Address Line 1<span className="required">*</span>:
						</b>
					</label>
					<div className="shipToAddressFieldWrapper">
						<input
							type="text"
							id="address-line-1"
							className="fullWidth"
							name="addressLine1"
							value={this.state.fields.addressLine1}
							placeholder={this.props.context === 'REGISTRATION' ? '' : 'Street address'}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							disabled={this.props.disabledFields.addressLine1}
						/>
						{this.state.errors.addressLine1 && <p className="message">Please enter address line 1</p>}
					</div>
				</div>
				<div className={`shipToAddressFormRow`}>
					<label htmlFor="address-line-2">
						<b>Address Line 2: </b>
					</label>
					<div className="shipToAddressFieldWrapper">
						<input
							type="text"
							id="address-line-2"
							className="fullWidth"
							name="addressLine2"
							value={this.state.fields.addressLine2}
							placeholder={this.props.context === 'REGISTRATION' ? '' : 'Subdivision / Project name'}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							disabled={this.props.disabledFields.addressLine2}
						/>
					</div>
				</div>
				<div className={`shipToAddressFormRow`}>
					<label htmlFor="address-line-3">
						<b>Address Line 3: </b>
					</label>
					<div className="shipToAddressFieldWrapper">
						<input
							type="text"
							id="address-line-3"
							className="fullWidth"
							name="addressLine3"
							value={this.state.fields.addressLine3}
							placeholder={this.props.context === 'REGISTRATION' ? '' : 'Lot#'}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							disabled={this.props.disabledFields.addressLine3}
						/>
					</div>
				</div>
				<div className={`shipToAddressFormRow${this.state.errors.city ? ' error' : ''}`}>
					<label htmlFor="city">
						<b>
							City<span className="required">*</span>:
						</b>
					</label>
					<div className="shipToAddressFieldWrapper">
						<input
							type="text"
							id="city"
							className="fullWidth"
							name="city"
							value={this.state.fields.city}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							disabled={this.props.disabledFields.city}
						/>
						{this.state.errors.city && <p className="message">Please enter city</p>}
					</div>
				</div>
				{!this.isCountrySelected('CA') && (
					<div className={`shipToAddressFormRow${this.state.errors.state ? ' error' : ''}`}>
						<label htmlFor="state">
							<b>State{this.isCountrySelected('US') && <span className="required">*</span>}:</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							{this.isCountrySelected('US') ? (
								<select
									id="state"
									className="fullWidth"
									name="state"
									value={this.state.fields.state}
									onChange={this.handleChange}
									onBlur={this.handleBlur}
									disabled={this.props.disabledFields.state}
								>
									<option value="">Select...</option>
									{USA_STATES.map(state => (
										<option key={state} value={state}>
											{state}
										</option>
									))}
								</select>
							) : (
								<input
									id="state"
									className="fullWidth"
									name="state"
									type="text"
									value={this.state.fields.state}
									onChange={this.handleChange}
									onBlur={this.handleBlur}
									disabled={this.props.disabledFields.state}
								/>
							)}
							{this.state.errors.state && <p className="message">Please select your state</p>}
						</div>
					</div>
				)}
				{!this.isCountrySelected('US') && (
					<div className={`shipToAddressFormRow${this.state.errors.province ? ' error' : ''}`}>
						<label htmlFor="province">
							<b>Province{this.isCountrySelected('CA') && <span className="required">*</span>}:</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							{this.isCountrySelected('CA') ? (
								<select
									id="province"
									className="fullWidth"
									name="province"
									value={this.state.fields.province}
									onChange={this.handleChange}
									onBlur={this.handleBlur}
									disabled={this.props.disabledFields.province}
								>
									<option value="">Select...</option>
									{CANADA_PROVINCES.map(province => (
										<option key={province} value={province}>
											{province}
										</option>
									))}
								</select>
							) : (
								<input
									type="text"
									id="province"
									className="fullWidth"
									name="province"
									value={this.state.fields.province}
									onChange={this.handleChange}
									onBlur={this.handleBlur}
									disabled={this.props.disabledFields.province}
								/>
							)}
							{this.state.errors.province && <p className="message">Please select your province</p>}
						</div>
					</div>
				)}
				{!this.isCountrySelected('US') ? (
					<div className={`shipToAddressFormRow${this.state.errors.postalCode ? ' error' : ''}`}>
						<label htmlFor="postal-code">
							<b>Postal Code{this.isCountrySelected('CA') && <span className="required">*</span>}:</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<input
								type="text"
								id="postal-code"
								className="fullWidth"
								name="postalCode"
								size={10}
								maxLength={10}
								value={this.state.fields.postalCode || ''}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								disabled={this.props.disabledFields.postalCode}
							/>
							{this.state.errors.postalCode && <p className="message">Please enter a valid postal code</p>}
						</div>
					</div>
				) : (
					<div className={`shipToAddressFormRow${this.state.errors.zipCode ? ' error' : ''}`}>
						<label htmlFor="zip-code">
							<b>Zip Code{this.isCountrySelected('US') && <span className="required">*</span>}:</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<input
								type="text"
								id="zip-code"
								className="fullWidth"
								name="zipCode"
								size={10}
								maxLength={7}
								value={this.state.fields.zipCode || ''}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								onKeyPress={this.onKeyPressOfNumber}
								disabled={this.props.disabledFields.zipCode}
							/>
							{this.state.errors.zipCode && <p className="message">Please enter a valid zip code</p>}
						</div>
					</div>
				)}
				{this.props.context === 'REGISTRATION' && (
					<div className={`shipToAddressFormRow${this.state.errors.phoneNumber ? ' error' : ''}`}>
						<label htmlFor="phone-number">
							<b>
								Phone Number<span className="required">*</span>:
							</b>
						</label>
						<div className="shipToAddressFieldWrapper">
							<input
								type="text"
								id="phone-number"
								className="fullWidth"
								name="phoneNumber"
								value={this.state.fields.phoneNumber}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								disabled={this.props.disabledFields.phoneNumber}
							/>
							{this.state.errors.phoneNumber &&
								(this.state.fields.phoneNumber === '' ? (
									<p className="message">Please enter your phone number</p>
								) : (
									<p className="message">
										{['US', 'CA'].includes(this.state.fields.country)
											? 'Please enter a valid 10-digit phone number, starting with the area code'
											: 'Please enter a valid phone number'}
									</p>
								))}
						</div>
					</div>
				)}
			</div>
		);
	}
}

ShipToAddress.defaultProps = {
	disabledFields: {}
};

export default ShipToAddress;



// WEBPACK FOOTER //
// ./src/App/components/common/shipToAddress.js